<script>
import Label from './Label.vue'

export default {
    props: {
        item: {
        type: Object,
        required: true,
        },
        selectedItem: {
        type: Object,
        required: false
        },
    },
    components: {
        Label
    },
    data() {
        return {
        };
    },   
    computed: {
    },
    watch: {
    }
};
</script>
<template>
    <div class="mb-4">
        <Label :item="item"/>
        <div class="cards-scrollable-item">
            <a :href="selectedItem.link_url" tabindex="0" role="button" class="quick-link-card">
                <div class="quick-link-card-top join-the-practice">
                    <span class="svg-icon">
                        <img :src="selectedItem.additionalProp1 && selectedItem.additionalProp1.icon">
                    </span>
                </div>
                <div class="quick-link-card-bottom">
                    {{selectedItem.label}}
                </div>
            </a>
        </div>
    </div>
</template>

<style scoped>
.svg-icon {
    display: inline-block;
    position: relative;
}
.quick-link-card-top.join-the-practice {
    border-top: 4px solid;
    border-color: #409954;
    background-color: #ffffff;
}
.quick-link-card-top {
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.quick-link-card {
    display: block;
    width: 218px;
    /* height: 180px; */
    text-decoration: none;
    transition: transform .2s ease-in;
    outline: none;
    /* margin-bottom: 1em; */
}
.quick-link-card-bottom {
    /* height: 90px; */
    padding: 14px 12px;
    padding-top: 0;
    color: #000;
    font-size: 14px;
    /* letter-spacing: 0; */
    /* line-height: 21px; */
    /* font-weight: 600; */
    background-color: #fff;
    text-align: center;
}
</style>